<template>
  <div>
    <div class="rightFixed">
      <div v-if="shouldShowCustomerService">
        <div class="customerService">
          <div class="close-btn" @click="toggleServicePanel">
            <i class="el-icon-close"></i>
          </div>
          <div class="customerIcon">
            <img
              src="@/assets/contactService.png"
              style="width: 100%; height: 100%"
            />
          </div>

          <div style="color: #fff; margin-top: 20px">
            <!-- <i class="el-icon-phone"></i> -->
            <span style="font-size: 15px; font-weight: 550; margin-left: 4px"
              >18613149026</span
            >
          </div>

          <div style="color: #fff; margin-top: 10px">
            <!-- <i class="el-icon-phone"></i> -->
            <span style="font-size: 15px; font-weight: 550; margin-left: 4px"
              >020-88521937</span
            >
          </div>

          <div class="weChatIcon">
            <img
              src="@/assets/serviceCode.png"
              style="width: 100%; height: 100%"
            />
            <div class="weChatText">微信扫码咨询</div>
          </div>
          <!-- <div class="applyText">
                        申请试用
                    </div> -->
          <div style="margin-top: 30px">
            <button class="vip-button" @click="applyHandle">
              <span class="vip-text">领取会员</span>
            </button>
          </div>
        </div>
      </div>

      <div v-else class="specificContent">
        <div style="margin: 10px">
          <el-popover placement="right" width="200" trigger="click">
            <div style="display: flex; justify-content: center">
              <img
                src="@/assets/serviceCode.png"
                style="width: 100%; height: 100%"
              />
            </div>
            <el-tooltip
              slot="reference"
              class="item"
              effect="dark"
              content="联系我们"
              placement="left"
            >
              <div class="weChat">
                <img
                  src="@/assets/weixi.png"
                  style="width: 20px; height: 20px"
                />
              </div>
            </el-tooltip>
          </el-popover>
        </div>
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="领取会员"
            placement="left"
          >
            <div class="weChat" @click="applyHandle">
              <img src="@/assets/aplay.png" style="width: 20px; height: 20px" />
            </div>
          </el-tooltip>
        </div>
        <div v-if="userBookFlag" style="margin: 10px">
          <el-tooltip
            class="item"
            effect="dark"
            content="使用手册"
            placement="left"
          >
            <div class="weChat" @click="userBookHandle">
              <img
                src="@/assets/userBook.png"
                style="width: 20px; height: 20px"
              />
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-dialog
      title="领取会员"
      :visible.sync="dialogFormVisible"
      :width="dialogWidth"
      class="apply-dialog"
    >
      <div class="form-container">
        <el-form :model="form" ref="form" :rules="rules" label-width="80px">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入姓名"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="tel">
            <el-input
              v-model="form.tel"
              placeholder="请输入手机号"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              v-model="form.companyName"
              placeholder="请输入公司名称"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input
              v-model="form.email"
              placeholder="请输入邮箱(选填)"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="promotion-info">
          <!-- 申请通过，平台赠送"专业版”会员全部功能使用权限(有效期 7天) -->
          申请通过，平台赠送99元3日包，可享受全部功能的权限（有效期3天）
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer
      title="使用手册"
      :visible.sync="drawerVisible"
      :direction="'rtl'"
      size="60%"
    >
      <userManual />
    </el-drawer>
  </div>
</template>

<script>
  import http from "@/utils/http";
  import userManual from "@/views/website/userManual/index.vue";

  export default {
    components: {
      userManual,
    },

    data() {
      return {
        isShowIcon: false,
        dialogFormVisible: false,
        form: {
          name: "",
          tel: "",
          companyName: "",
          email: "",
        },
        rules: {
          name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
          tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
          companyName: [
            { required: true, message: "请输入公司名称", trigger: "blur" },
          ],
        },
        isMobile: false,
        confirmLoading: false,
        isCustomerServiceVisible: true,
        drawerVisible: false,
      };
    },
    computed: {
      dialogWidth() {
        return this.isMobile ? "90%" : "30%";
      },
      shouldShowCustomerService() {
        return (
          (this.$route.path === "/website/index" ||
            this.$route.path === "/website/priceAll") &&
          this.isCustomerServiceVisible
        );
      },

      userBookFlag() {
        return (
          this.$route.path !== "/website/index" &&
          this.$route.path !== "/website/priceAll"
        );
      },
    },
    created() {
      this.checkScreenSize();
      window.addEventListener("resize", this.checkScreenSize);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.checkScreenSize);
    },
    methods: {
      toggleServicePanel() {
        this.isCustomerServiceVisible = !this.isCustomerServiceVisible;
      },

      checkScreenSize() {
        this.isMobile = window.innerWidth < 768;
      },
      // 申请体验
      applyHandle() {
        this.dialogFormVisible = true;
      },
      // 填完后确认
      confirmHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.confirmLoading = true;
            http
              .post(`/userRequestTrialAccess/add`, this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("申请成功");
                  this.dialogFormVisible = false;
                  // 清空表单
                  this.form = {
                    name: "",
                    phone: "",
                    companyName: "",
                    email: "",
                  };
                  this.confirmLoading = false;
                }
              })
              .catch((err) => {
                this.dialogFormVisible = false;
                this.confirmLoading = false;
                // this.$message.error('申请失败');
              });
          } else {
            return false;
          }
        });
      },

      userBookHandle() {
        this.drawerVisible = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .iconShow {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    width: 30px;
    height: 30px;
    background-color: #409eff;
  }

  .rightFixed {
    position: fixed;
    right: 0;
    bottom: 50px;
    z-index: 10;
  }

  .contentRight {
    display: flex;
    align-items: center;
  }

  .specificContent {
    font-size: 13px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .weChat {
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.1),
      inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  ::v-deep .el-dialog {
    border-radius: 20px;
  }

  @media (max-width: 768px) {
    .apply-dialog,
    .contact-dialog {
      ::v-deep .el-dialog {
        margin-top: 5vh !important;
      }

      .form-container {
        .promotion-info {
          font-size: 13px;
        }
      }
    }
  }

  //  平板端样式
  @media (min-width: 768px) and (max-width: 1199px) {
    ::v-deep(.el-dialog) {
      width: 60% !important;
    }
  }

  .customerService {
    width: 140px;
    // height: 400px;
    margin-right: 20px;
    background-color: #6377ee;
    border-top-left-radius: 70px;
    border-top-right-radius: 70px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: flex;
    align-items: center;
    // justify-content: center;
    flex-direction: column;
    padding: 10px;
    box-sizing: border-box;
    padding-top: 20px;
  }

  .customerIcon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
  }

  .applyText {
    background-color: #fff;
    width: 100%;
    height: 40px;
    font-size: 15px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #6377ee;
  }

  .weChatIcon {
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    padding: 3px;
    box-sizing: border-box;
    border-radius: 10px;
    height: 120px;
    width: 100%;
    // margin-bottom: 20px;
  }

  .applyBtn {
  }

  .vip-button {
    padding: 10px;
    font-size: 20px;
    font-weight: 600;
    font-family: "Ma Shan Zheng", cursive;
    color: #8389ff;
    background: linear-gradient(107deg, #ffffff, #ffd68b);
    border: none;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    animation: pulse-c6e01062 2s ease-in-out infinite;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .vip-button::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent 30%,
      rgba(255, 255, 255, 0.3) 50%,
      transparent 70%
    );
    transform: rotate(45deg);
    animation: shine 3s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    }

    50% {
      transform: scale(1.1);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
    }

    100% {
      transform: scale(1);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    }
  }

  @keyframes shine {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
    }

    100% {
      transform: translateX(100%) translateY(100%) rotate(45deg);
    }
  }

  .vip-button:hover {
    animation: pulse-hover 0.5s ease-in-out infinite;
  }

  @keyframes pulse-hover {
    0% {
      transform: scale(1.1);
    }

    50% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1.1);
    }
  }

  .vip-text {
    position: relative;
    z-index: 1;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    letter-spacing: 2px;
  }

  .weChatText {
    font-size: 13px;
    color: #ffffff;
    margin-top: 10px;
    text-align: center;
  }

  /* 关闭按钮样式 */
  .close-btn {
    position: absolute;
    top: 0px;
    left: 0px;
    cursor: pointer;
    color: #ccc;
    transition: color 0.3s ease;
  }

  .close-btn:hover {
    color: red;
  }

  ::v-deep .el-drawer__header > :first-child {
    font-weight: 600;
    font-size: 30px;
    color: #000;
  }

  ::v-deep .el-drawer__header {
    margin-bottom: 0px;
  }
</style>
